import { type Message as TwilioMessage } from '@twilio/conversations';

import { type ChatMessage } from './chat-message';
import { chatMessageAttributesSchema } from './chat-message-attributes';
import { TextChatMessage } from './text-chat-message';

export namespace ChatMessageFactory {

  /**
   * Create message.
   * @param message Twilio message instance.
   */
  export function createMessage(message: TwilioMessage): ChatMessage {
    const data = chatMessageAttributesSchema.parse(
      message.attributes,
    );

    const { type: messageType } = data;

    switch (messageType) {
      case 'text':
        return createTextChatMessage(message);
      default:
        // eslint-disable-next-line no-case-declarations
        const _exhaustiveCheck: never = messageType;
        throw Error(`Unknown message type: ${String(messageType)}`);
    }
  }
}

/**
 * Create text chat message.
 * @param message Twilio message instance.
 * @throws Error if twilio message is not a text message.
 */
function createTextChatMessage(message: TwilioMessage): TextChatMessage {
  const messageBody = message.body ?? '';
  return new TextChatMessage({
    twilioMessage: message,
    body: messageBody,
  });
}
